import { defineComponent } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, createElementVNode, mergeProps, renderSlot, createTextVNode, toDisplayString, Fragment, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

/**
 * TODO: Using "v-bind=$attrs" on label might not work for things like "aria-label"
 */
var script = defineComponent({
  name: 'OrLabel',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      REQUIRED_SYMBOL: '*'
    };
  },
  computed: {
    rootClasses() {
      return ['or-label', 'or-label-root', {
        'has-slot': this.$slots.append
      }, this.$attrs.class];
    },
    localAttrs() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
      const {
        class: _,
        ...rest
      } = this.$attrs;
      return rest;
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.rootClasses)
  }, [createElementVNode("label", mergeProps({
    class: "or-label-content"
  }, _ctx.localAttrs), [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)]), _ctx.isRequired ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.REQUIRED_SYMBOL), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)], 16 /* FULL_PROPS */), renderSlot(_ctx.$slots, "append")], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-f91aab88 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-f91aab88 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-label[data-v-f91aab88] {\n  width: 100%;\n  font-size: var(--fs-0);\n  line-height: var(--lh-0);\n  color: var(--c-neutral-4);\n}\n.or-label-content[data-v-f91aab88] {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-all;\n  white-space: nowrap;\n}\n.or-label .or-icon[data-v-f91aab88] {\n  font-size: var(--fs-1);\n}\n.or-label.has-slot[data-v-f91aab88] {\n  display: flex;\n  align-items: center;\n}\n.or-label.has-slot .or-label-content[data-v-f91aab88] {\n  margin-right: auto;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-f91aab88";
script.__file = "src/components/or-label/OrLabel.vue";

export { script as s };
